/** 提示音：放在 public/tip.mp3，避免打包路径问题 */

const TIP_SRC = `${process.env.BASE_URL || '/'}tip.mp3`.replace(/([^:]\/)\/+/g, '$1')

let tipAudio = null
let unlocked = false
let unlockBound = false

function getTipAudio() {
  if (typeof window === 'undefined' || typeof Audio === 'undefined') return null
  if (!tipAudio) {
    tipAudio = new Audio(TIP_SRC)
    tipAudio.preload = 'auto'
    tipAudio.loop = false
    tipAudio.volume = 1
  }
  return tipAudio
}

/** 用户首次点击/按键后解锁，避免浏览器拦截自动播放 */
export function unlockTipSound() {
  const audio = getTipAudio()
  if (!audio || unlocked) return
  const prevMuted = audio.muted
  audio.muted = true
  const p = audio.play()
  const done = () => {
    try {
      audio.pause()
    } catch (e) {
      /* ignore */
    }
    try {
      audio.currentTime = 0
    } catch (e) {
      /* ignore */
    }
    audio.muted = prevMuted
    unlocked = true
  }
  if (p && typeof p.then === 'function') {
    p.then(done).catch(() => {
      audio.muted = prevMuted
    })
  } else {
    done()
  }
}

export function bindTipSoundUnlock() {
  if (typeof document === 'undefined' || unlockBound) return
  unlockBound = true
  const onInteract = () => {
    unlockTipSound()
    document.removeEventListener('click', onInteract, true)
    document.removeEventListener('touchstart', onInteract, true)
    document.removeEventListener('keydown', onInteract, true)
  }
  document.addEventListener('click', onInteract, true)
  document.addEventListener('touchstart', onInteract, true)
  document.addEventListener('keydown', onInteract, true)
}

/** 播放提示音，每次只播一遍（不循环） */
export function playTipSound() {
  try {
    const audio = getTipAudio()
    if (!audio) return
    audio.loop = false
    audio.muted = false
    const restart = () => {
      try {
        audio.currentTime = 0
      } catch (e) {
        /* ignore */
      }
      const playPromise = audio.play()
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          bindTipSoundUnlock()
        })
      }
    }
    if (audio.readyState >= 2) {
      restart()
    } else {
      audio.addEventListener('canplaythrough', restart, { once: true })
      try {
        audio.load()
      } catch (e) {
        /* ignore */
      }
      restart()
    }
  } catch (e) {
    bindTipSoundUnlock()
  }
}
